// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Tab } from 'semantic-ui-react';
import { connect } from 'react-redux';
// local
// css
import './EditConfirmBody.scss';
// views
import TabDelivered from './TabDelivered';
import TabReturned from './TabReturned';
import ConfirmSendModal from './ConfirmSendModal';
// actions
import { save, reset, back } from 'app/redux/actions/editConfirm/data';
import { openModal as openBackModal } from 'app/redux/actions/editConfirm/backModal';
import { openModal as openSendModal } from 'app/redux/actions/editConfirm/confirmModal';

// auxiliar function to only send the needed data to backend
const mapAux = r => ({ id: r.id, cylinderQtdConfirmedEdit: r.cylinderQtdConfirmedEdit });

class EditConfirmBody extends Component {
    constructor(props) {
        super(props);
        this.panes = [
            {
                menuItem: 'Entregas',
                render: () => <TabDelivered />,
            },
            {
                menuItem: 'Devoluções',
                render: () => <TabReturned />,
            },
        ];
    }

    componentWillUnmount() {
        this.props.dispatch(reset());
    }

    onClickCancel = () => {
        const { returned, delivered } = this.props.editConfirm;
        let found = delivered.find(item => item.isEdit === true || item.isSaved === true);
        if (!found) {
            returned.find(item => item.isEdit === true || item.isSaved === true);
        }
        if (found) {
            this.props.dispatch(openBackModal());
        } else {
            this.props.dispatch(back());
        }
    };

    onClickSave = () => {
        const { returned, delivered } = this.props.editConfirm;
        // filter the tabs for only the saved items
        const d = delivered.filter(r => r.isSaved === true).map(mapAux);
        const r = returned.filter(r => r.isSaved === true).map(mapAux);
        const array = d.concat(r);
        this.props.dispatch(openSendModal(array));
    };

    onClickConfirm = array => this.props.dispatch(save(array, this.props.editConfirm.query));

    render() {
        return (
            <div id="edit-confirm-body">
                <div className="buttons flex">
                    <span id="btn-cancel" onClick={this.onClickCancel}>
                        Cancelar
                    </span>
                    <Button content="SALVAR ALTERAÇÕES" onClick={this.onClickSave} />
                </div>
                <Tab menu={{ secondary: true, pointing: true }} panes={this.panes} renderActiveOnly />
                <ConfirmSendModal onClickConfirm={this.onClickConfirm} />
            </div>
        );
    }
}

EditConfirmBody.propTypes = {
    dispatch: PropTypes.func,
    editConfirm: PropTypes.object,
};

const mapStateToProps = state => ({
    editConfirm: state.editConfirm,
});
export default connect(mapStateToProps)(EditConfirmBody);
